export class Product {
	private element: HTMLElement;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	private handleClick = ({ target }) => {
		if (target.closest('.product-images-main__slide') && !target.tag !== 'iframe') window.app.modal.open('#product-images-modal');
	};

	private init = (): void => {
		this.element.addEventListener('click', this.handleClick);
	};
}
